import React from 'react';
import { useAskFreya } from '../../pages/askFreya/AskFreyaContext';
import InitialChatInput from './InitialChatInput';
import FollowUpChatInput from './FollowUpChatInput';

const ChatInput: React.FC = () => {
  const { sendMessage, isLoading, messages } = useAskFreya();
  const hasMessages = messages.length > 0;
  const suggestions = hasMessages ? ['Show me the average price for WICE', 'Question B'] : [];
  const [text, setText] = React.useState('');

  const handleSend = () => {
    if (text.trim() && !isLoading) {
      sendMessage(text);
      setText('');
    }
  };

  const handleSuggestionClick = (suggestion: string) => {
    if (!isLoading) {
      sendMessage(suggestion);
    }
  };

  if (hasMessages) {
    return (
      <FollowUpChatInput
        text={text}
        setText={setText}
        isLoading={isLoading}
        onSend={handleSend}
        suggestions={suggestions}
        onSuggestionClick={handleSuggestionClick}
      />
    );
  }

  return (
    <InitialChatInput
      text={text}
      setText={setText}
      isLoading={isLoading}
      onSend={handleSend}
      suggestions={suggestions}
      onSuggestionClick={handleSuggestionClick}
    />
  );
};

export default ChatInput;
